import { useEffect, useMemo } from "react";
import { db } from "~/db/db";
import { getEstruturaSincronizacao } from "~services/GlobalServices";

const useWorker = ({ table }) => {
  const worker = useMemo(() => new Worker(new URL("~/db/worker.js", import.meta.url), { type: "module" }), []);

  useEffect(() => {
    return () => {
      worker.terminate();
    };
  }, [worker]);

  function save(data, clearCache = null) {
    worker.postMessage({ table, data, tipo: "bulkPut" });
    worker.onmessage = function () {};
  }

  function remove(data) {
    worker.postMessage({ table, data, tipo: "remove" });
    worker.onmessage = function () {};
  }

  return {
    save,
    remove,
  };
};

export default useWorker;
